/**
 * 同步执行hook
 */
export default class Hook {
  hookFns: Function[] = [];

  tap(fn: Function) {
    this.hookFns.push(fn);
  }

  call(args: any) {
    this.hookFns.forEach((fn) => fn(args));
  }
}
